// extracted by mini-css-extract-plugin
module.exports = {"icons":"SocialLinks-module__icons___nS3aG","icon":"SocialLinks-module__icon___rokes"};